import * as React from 'react';

const MenuTv = () => (
  <svg width={28} height={26} viewBox="0 0 28 26" stroke="none" strokeWidth={1} fillRule="evenodd">
    <path
      fill="#FFFFFF"
      d="M18.695,0.305 C18.288,-0.102 17.627,-0.102 17.22,0.305 L13,5.086 L8.78,0.305 C8.373,-0.102 7.713,-0.102 7.305,0.305 C6.898,0.714 6.898,1.376 7.305,1.785 L12.202,7.704 C12.421,7.924 12.713,8.016 13,7.998 C13.287,8.016 13.579,7.924 13.798,7.704 L18.695,1.785 C19.102,1.376 19.102,0.714 18.695,0.305 Z"
    />
    <path
      fill="#FFFFFF"
      fillRule="nonzero"
      d="M26.154,6.001 C26.152,6.001 1.855,6 1.855,6 C0.828,6.003 0,5.806 0,6.797 L0,10.992 L0,25.144 C0,26.169 0.831,26 1.855,26 L26.147,26 C27.172,26 28.002,26.169 28.002,25.144 L28.002,10.993 L28.002,6.798 C28.003,5.806 27.176,6.003 26.154,6.001 Z"
    />
    <circle fill="#1C1F34" fillRule="nonzero" cx={25} cy={14} r={1} />
    <rect fill="#1C1F34" x={23} y={18} width={3} height={5} rx={1} />
    <circle fill="#1C1F34" fillRule="nonzero" cx={25} cy={10} r={1} />
    <path
      fill="#677BC5"
      d="M20,8 L3,8 C2.447,8 2,8.447 2,9 L2,23 C2,23.552 2.448,24 3,24 L20,24 C20.552,24 21,23.552 21,23 L21,9 C21,8.447 20.553,8 20,8 Z"
    />
    <path
      stroke="#1C1F34"
      fill="none"
      fillRule="nonzero"
      d="M20,8.5 L3,8.5 C2.723,8.5 2.5,8.723 2.5,9 L2.5,23 C2.5,23.276 2.724,23.5 3,23.5 L20,23.5 C20.276,23.5 20.5,23.276 20.5,23 L20.5,9 C20.5,8.723 20.277,8.5 20,8.5 Z"
    />
    <polyline
      stroke="#1C1F34"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="11.432 9.251 13.631 11.789 11.304 12.969 12.349 13.724 11.595 15.01 14.097 15.886 15.058 13.622 18.371 11.347"
    />
    <polyline
      stroke="#1C1F34"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="19.591 14.934 16.768 15.268 15.506 15.941 14 15.941 12.844 17.769 17.614 17.873 15.151 19.798 16.406 21"
    />
    <path
      fill="#1C1F34"
      d="M15.592,17.851 L16.836,15.592 L14,16.068 C14,16.068 13.271,17.077 13.335,17.425 C13.4,17.773 15.592,17.851 15.592,17.851 Z"
    />
  </svg>
);

export default MenuTv;



// WEBPACK FOOTER //
// ./src/assets/images/icons/menu-tv.js